import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShipDetailService {
  private apiUrl = '/shipdetails';
  private apiSpringUrl = '/spring/shipdetails';

  constructor(private http: HttpService) { }

  get(ownerId ?: number, shiphId ?: string, shipBeginDt ? : string, shipEndDt ? : string): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    if (shiphId !== null && shiphId !== undefined) {
      url = url + `&shiphId=${shiphId}`
    }
    if (shipBeginDt !== null && shipBeginDt !== undefined) {
      url = url + `&shipBeginDt=${shipBeginDt}`
    }
    if (shipEndDt !== null && shipEndDt !== undefined) {
      url = url + `&shipEndDt=${shipEndDt}`
    }
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/ship-detail/ship-detail.service.ts